export default "__VITE_PUBLIC_ASSET__abd78ccf__"